import React, { useEffect, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import Topbar from '../Components/Topbar'
import profDefault from '../Images/def.png'
import { Link } from 'react-router-dom'
import defaultCover from '../Images/coverbg.jpg'
import Button from "react-bootstrap/Button";
import { app } from "../firebase.js"
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import BottomNav from '../Components/BottomNav'

import { Card, Row, Col, ListGroup, Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faClock, faEye, faFaceSmile, faIdCard, faUser, faWallet } from '@fortawesome/free-solid-svg-icons'

import { getDatabase, ref as dbRef, get, set, runTransaction } from "firebase/database";
import Chart from "react-apexcharts";
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

import icInstagram from '../Images/instagram2.png'
import icYoutube from '../Images/youtube.png'
import icTiktok from '../Images/tiktok.png'
import icLinkedin from '../Images/Linkedin.svg'
import icTwitter from '../Images/Twitter.svg'
import subsImg from '../Images/p_img3.svg'
import VerificationStatus from './VerificationStatus.js'
import SocialCardModal from '../Components/SocialCardModal.js'


function Profile() {

  const [activeTab, setActiveTab] = useState('socials');
  const auth = getAuth();
  const db = getFirestore(app);
  const navigate = useNavigate();
  const [Username, setUsername] = useState("")
  const [UserEmail, setUserEmail] = useState("")

  const [userId, setUserId] = useState()

  const [dateJoined, setDateJoined] = useState("");
  const [profileViews, setProfileViews] = useState(0);

  const [subscriptionExpiry, setSubscriptionExpiry] = useState(null)
  const [isSubscriptionActive, setIsSubscriptionActive] = useState(false)

  const rdb = getDatabase(app);



  const [profileData, setProfileData] = useState({
    userName: "",
    theUsername: "",
    email: "",
    phoneNumber: "",
    mpesaNumber: "",
    profileImage: profDefault,
    coverImage: defaultCover,
    adsNotAccepted: {},
    socials: {},
    socialUrls: {}
  });

  const [selectedPlatforms, setSelectedPlatforms] = useState({
    instagram: false,
    tiktok: false,
    youtube: false,
    twitter: false
  });

  const [socialStats, setSocialStats] = useState({
    instagram: {},
    tiktok: {},
    youtube: {},
    twitter: {}
  });


  const [servicePricing, setServicePricing] = useState({});
  const [profileLink, setProfileLink] = useState("");

  const [verifiedSocials, setVerifiedSocials] = useState({});
  const isVerified = (platform) =>
    verifiedSocials?.[platform]?.status === "verified";

  const [showSocialModals, setShowSocialModals] = useState({});
  const [userProfile, setUserProfile] = useState({ profilePhoto: null, coverPhoto: null, countryName: null })



  useEffect(() => {
    const cached = localStorage.getItem("profileData")
    if (cached) setProfileData(JSON.parse(cached))

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login")
        return
      }

      const uid = user.uid
      setUserId(uid)


      const docRef = doc(db, "users", uid)
      const snap = await getDoc(docRef)

      if (snap.exists()) {
        const data = snap.data()

        // Log selected platforms
        if (data.socials) {
          const sel = {
            instagram: data.socials.instagram === "selected" || data.socials.instagram === true,
            tiktok: data.socials.tiktok === "selected" || data.socials.tiktok === true,
            youtube: data.socials.youtube === "selected" || data.socials.youtube === true,
            twitter: data.socials.twitter === "selected" || data.socials.twitter === true
          };
          //console.log("selected platforms:", sel);
          setSelectedPlatforms(sel);
        }

        if (data.socialStats) {
          setSocialStats({
            instagram: data.socialStats.instagram || {},
            tiktok: data.socialStats.tiktok || {},
            youtube: data.socialStats.youtube || {},
            twitter: data.socialStats.twitter || {},

            instagramURL: data.instagramUrl || {},
          });
        }

        if (data.servicePricing) {
          setServicePricing(data.servicePricing);
        }

        const expiry = data.subscriptionExpiry
          ? data.subscriptionExpiry.toDate()
          : null

        setSubscriptionExpiry(expiry)
        setIsSubscriptionActive(expiry && expiry > new Date())



        setProfileLink(`${window.location.origin}/${data.theUsername}`)


        const fresh = {
          userName: data.userName || "",
          theUsername: data.theUsername || "",
          email: data.email || "",
          phoneNumber: data.phoneNumber || "",
          mpesaNumber: data.mpesaNumber || "",
          profileImage: data.profileImage || profDefault,
          coverImage: data.coverImage || defaultCover,
          adsNotAccepted: data.adsNotAccepted || {},
          socials: data.socials || {},
          socialUrls: {
            instagram: data.instagramUrl || "",
            tiktok: data.tiktokUrl || "",
            youtube: data.youtubeUrl || "",
            linkedin: data.linkedinUrl || "",
            facebook: data.facebookUrl || "",
            twitter: data.twitterUrl || ""
          },
          subscriptionEnabled: data.subscriptionEnabled || false,
          subscriptionPrice: data.subscriptionPrice || 0,
          packageDetails: data.packageDetails || []
        }

        if (data.verifiedSocials) {
          setVerifiedSocials(data.verifiedSocials);
        }

        setUserProfile({
          profilePhoto: data.profileImage || null,
          coverPhoto: data.coverImage || null,
          country: data.countryName || "Unknown",
          profileLink: data.theUsername
        });

        const old = JSON.parse(localStorage.getItem("profileData") || "{}")
        if (JSON.stringify(old) !== JSON.stringify(fresh)) {
          setProfileData(fresh)
          localStorage.setItem("profileData", JSON.stringify(fresh))
        }

        // --- Date Joined ---
        // --- Date Joined ---
        if (data.timestamp) {
          const joinDate = data.timestamp.toDate ? data.timestamp.toDate() : new Date(data.timestamp)
          const now = new Date()
          const diffMs = now - joinDate
          const diffSeconds = Math.floor(diffMs / 1000)
          const diffMinutes = Math.floor(diffSeconds / 60)
          const diffHours = Math.floor(diffMinutes / 60)
          const diffDays = Math.floor(diffHours / 24)
          const diffMonths = (now.getFullYear() - joinDate.getFullYear()) * 12 + (now.getMonth() - joinDate.getMonth())
          const diffYears = now.getFullYear() - joinDate.getFullYear()

          let joinedText = ""
          if (diffSeconds < 60) joinedText = `${diffSeconds} second${diffSeconds !== 1 ? "s" : ""} ago`
          else if (diffMinutes < 60) joinedText = `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""} ago`
          else if (diffHours < 24) joinedText = `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`
          else if (diffDays < 30) joinedText = `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`
          else if (diffMonths < 12) joinedText = `${diffMonths} month${diffMonths !== 1 ? "s" : ""} ago`
          else joinedText = `${diffYears} year${diffYears !== 1 ? "s" : ""} ago`

          setDateJoined(joinedText)
        }


        // --- Profile Views ---
        const viewsRef = dbRef(rdb, `profileViews/${uid}`)
        runTransaction(viewsRef, (current) => (current || 0) + 1)
          .then(result => setProfileViews(result.snapshot.val()))
          .catch(err => console.error("Profile view error:", err))
      }
    })

    return () => unsubscribe()
  }, [])


  const { userName, theUsername, email, phoneNumber, mpesaNumber, profileImage, coverImage, adsNotAccepted, socials, socialUrls } = profileData;

  useEffect(() => {
    if (!profileData.userName || !profileData.theUsername) return;

    const title = `${profileData.userName} | Zindua Influencer Profile`;
    const descContent = `Check out ${profileData.userName}'s influencer profile on Zindua. View your social stats, subscription options, and portfolio.`;

    document.title = title;

    // Meta description
    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", descContent);

    // Open Graph tags
    const ogTags = [
      { property: "og:title", content: title },
      { property: "og:description", content: descContent },
      { property: "og:type", content: "profile" },
      { property: "og:url", content: window.location.href },
      { property: "og:image", content: profileData.profileImage || "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // JSON-LD structured data for influencer profile
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "name": profileData.userName,
      "url": window.location.href,
      "image": profileData.profileImage || "https://zindua.app/logo192.png",
      "sameAs": Object.values("Zindua App").filter(Boolean),
      "jobTitle": "Influencer",
      "mainEntityOfPage": window.location.href
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [profileData]);


  const data = {
    series: [
      {
        data: [20, 18, 35, 30, 32]
      }
    ],
    options: {
      chart: {
        type: "bar",
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          columnWidth: "12"
        }
      },
      colors: ["#f7b6c8"],
      tooltip: { enabled: false },
      xaxis: {
        categories: [" ", " ", " ", " ", " "]
      },
      yaxis: {
        show: false

      },
      grid: { show: false },
      dataLabels: { enabled: false }
    }
  };


  const handleCopyLink = () => {
    navigator.clipboard.writeText(profileLink)
      .then(() => {
        swal("Copied!", "Share this link on your socials to get more sign ups and ad bookings.", "success");
      })
      .catch(err => console.error('Copy failed', err));
  };

  const showModal = showSocialModals["image"] || false;

  const formatNumber = (num) => {
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'm';
    if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
    return num.toString();
  };




  return (
    <div className='mainDashboard'>
      <div className="desktopOnly">
        <LeftBar />
      </div>
      <div className='mainContent'>
        <Topbar />
        <VerificationStatus />

        <section className='topProfile'>

          <div className='profileCover'>
            <img src={coverImage} alt="" />
          </div>

          <div className='profilePhoto'>
            <img src={profileImage} alt="" />
          </div>

          <div className='topProfileCont'>
            <div>
              <h2>{userName}</h2>
              <p>
                @{theUsername
                  ? theUsername.length > 15
                    ? theUsername.substring(0, 15) + '...'
                    : theUsername
                  : ''}
              </p>

            </div>

            <Link to="/edit-profile">Edit Profile</Link>
          </div>
        </section>

        {/* Tabs */}
        <div className="tabs" style={{ display: 'flex', marginBottom: '20px' }}>
          <button
            className={activeTab === 'socials' ? 'activeTab' : ''}
            onClick={() => setActiveTab('socials')}
            style={{ marginRight: '10px' }}
          >
            Portfolio
          </button>
          <button
            className={activeTab === 'subscriptions' ? 'activeTab' : ''}
            onClick={() => setActiveTab('subscriptions')}
            style={{ marginRight: '10px' }}
          >
            Subscription
          </button>
          {/* <button
            className={activeTab === 'tip' ? 'activeTab' : ''}
            onClick={() => setActiveTab('tip')}
          >
            Tip Influencer
          </button> */}
        </div>

        {activeTab === 'socials' && (
          <section className='profileStatMain'>
            <div className='profileStatMain1'>
              <div className='profileStatMain1Top'>
                <div className='profileStatMain1Top1'>
                  <FontAwesomeIcon icon={faFaceSmile} /> <span>Profile</span>
                </div>
                <div className='profileStatMainCont'>
                  <p>Hi, im {userName}</p>
                  <h6>Date Joined</h6>
                  <p><FontAwesomeIcon icon={faClock} /> {dateJoined}</p>
                  <h6>Profile Views</h6>
                  <p><FontAwesomeIcon icon={faEye} /> {profileViews} Views</p>
                  <h6>Profile Card</h6>
                  <p style={{ cursor: 'pointer', color: '#0d6efd' }} onClick={() =>
                    setShowSocialModals((prev) => ({ ...prev, ["image"]: true }))
                  }><FontAwesomeIcon icon={faIdCard} /> View card</p>

                  <button className="shareButton" onClick={handleCopyLink}>
                    <FontAwesomeIcon icon={faShareAlt} />
                    Share My Account
                  </button>




                </div>
              </div>

              <div className='profileStatMain1Bott'>
                <div className='profileStatMain1Top11'>
                  <FontAwesomeIcon icon={faWallet} /> <span>My Service Pricing</span>
                </div>

                <div className='pricingCardsContainer'>
                  {Object.keys(servicePricing).length === 0 && (
                    <p className='text-muted mt-2'>No pricing added yet</p>
                  )}

                  {['instagram', 'tiktok', 'youtube', 'twitter'].map(platform => {
                    const data = servicePricing[platform];
                    const isSelected = selectedPlatforms[platform];

                    if (!isSelected || !data) return null;

                    const direct = data.directBrandContent;
                    const directHasPost = direct && direct.post;
                    const directHasStory = direct && direct.story;
                    const showDirect = direct && (directHasPost || directHasStory);

                    const cgc = data.creatorGeneratedContent;
                    const showCGC = cgc && cgc.description && cgc.price;

                    if (!showDirect && !showCGC) return null;

                    return (
                      <div className={`pricingCard ${platform} mt-3`} key={platform}>
                        <div className='pricingCardHeader'>
                          <FontAwesomeIcon
                            icon={
                              platform === 'instagram' ? faInstagram :
                                platform === 'tiktok' ? faTiktok :
                                  platform === 'youtube' ? faYoutube :
                                    faTwitter
                            }
                          />
                          <span className='ms-2 text-capitalize'>{platform}</span>
                        </div>

                        {showDirect && (
                          <div className='pricingSection'>
                            <div className='pricingTitle'>Direct Brand Content</div>

                            {directHasPost && (
                              <div>Post Upload: KES {Number(direct.post).toLocaleString()}</div>
                            )}

                            {directHasStory && (
                              <div>Story Upload: KES {Number(direct.story).toLocaleString()}</div>
                            )}
                          </div>
                        )}

                        {showCGC && (
                          <div className='pricingSection2'>
                            <div className='pricingTitle'>Creator Generated Content</div>
                            <div>{cgc.description}</div>
                            <div>KES {Number(cgc.price).toLocaleString()}</div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className='profileStatMain2'>

              {/* instagram */}
              {selectedPlatforms.instagram && (
                <div className='profileSocialCard igCard'>
                  <h6>Instagram {isVerified("instagram") && (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="ms-2 text-success"
                    />
                  )}</h6>

                  <div className='profileSocialCardTop igCardTop'>
                    <a href={'https://www.instagram.com/' + profileData.socialUrls.instagram || '#'} target='_blank' rel='noopener noreferrer'>
                      <img src={icInstagram} alt="" />
                    </a>

                    <div>
                      <p>Followers</p>
                      <h4>{formatNumber(socialStats.instagram.followers || 0)}</h4>
                    </div>
                  </div>

                  <div className='profileSocialCont'>
                    <div>
                      <p>Impression</p>
                      <h4>{formatNumber(socialStats.instagram.impressions || 0)}</h4>

                      <br />

                      <p>Engagement</p>
                      <h4>{formatNumber(socialStats.instagram.engagement || 0)}</h4>
                    </div>

                    <div className='profilesocialChart'>
                      <Chart
                        options={data.options}
                        series={data.series}
                        type="bar"
                        height={200}
                        width={150}
                        className="socialChart"
                      />
                      <div className='bottomSocialStats'>
                        <p>Last 90 Days</p>
                        <a href={'https://www.instagram.com/' + profileData.socialUrls.instagram || '#'} target='_blank' rel='noopener noreferrer'>Open Instagram</a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* twitter */}
              {selectedPlatforms.twitter && (
                <div className='profileSocialCard twitterCard'>
                  <h6>Twitter {isVerified("twitter") && (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="ms-2 text-success"
                    />
                  )}</h6>

                  <div className='profileSocialCardTop twitterTop'>
                    <a href={'https://x.com/' + profileData.socialUrls.twitter || '#'} target='_blank' rel='noopener noreferrer'>
                      <img src={icTwitter} alt="" />
                    </a>

                    <div>
                      <p>Followers</p>
                      <h4>{formatNumber(socialStats.twitter.followers || 0)}</h4>
                    </div>
                  </div>

                  <div className='profileSocialCont'>
                    <div>
                      <p>Tweet impressions</p>
                      <h4>{formatNumber(socialStats.twitter.tweetImpressions || 0)}</h4>

                      <br />

                      <p>Profile Views</p>
                      <h4>{formatNumber(socialStats.twitter.profileViews || 0)}</h4>

                    </div>

                    <div className='profilesocialChart'>
                      <Chart
                        options={data.options}
                        series={data.series}
                        type="bar"
                        height={200}
                        width={150}
                        className="socialChart"
                      />
                      <div className='bottomSocialStats'>
                        <p>Last 90 Days</p>
                        <a href={'https://www.x.com/' + profileData.socialUrls.twitter || '#'} target='_blank' rel='noopener noreferrer'>Open Twitter / X</a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* tiktok */}
              {selectedPlatforms.tiktok && (
                <div className='profileSocialCard tiktokCard'>
                  <h6>TikTok {isVerified("tiktok") && (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="ms-2 text-success"
                    />
                  )}</h6>

                  <div className='profileSocialCardTop tiktokCardTop'>
                    <a href={'http://tiktok.com/@' + profileData.socialUrls.tiktok || '#'} target='_blank' rel='noopener noreferrer'>
                      <img src={icTiktok} alt="" />
                    </a>

                    <div>
                      <p>Followers</p>
                      <h4>{formatNumber(socialStats.tiktok.followers || 0)}</h4>
                    </div>
                  </div>

                  <div className='profileSocialCont'>
                    <div>
                      <p>Video impressions</p>
                      <h4>{formatNumber(socialStats.tiktok.impressions || 0)}</h4>

                      <br />

                      <p>Total Likes</p>
                      <h4>{formatNumber(socialStats.tiktok.likes || 0)}</h4>
                    </div>

                    <div className='profilesocialChart'>
                      <Chart
                        options={data.options}
                        series={data.series}
                        type="bar"
                        height={200}
                        width={150}
                        className="socialChart"
                      />
                      <div className='bottomSocialStats'>
                        <p>Last 60 Days</p>
                        <a href={'https://www.tiktok.com/@' + profileData.socialUrls.tiktok || '#'} target='_blank' rel='noopener noreferrer'>Open TikTok</a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* youtube */}
              {selectedPlatforms.youtube && (
                <div className='profileSocialCard fbCard'>
                  <h6>Youtube {isVerified("youtube") && (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="ms-2 text-success"
                    />
                  )}</h6>

                  <div className='profileSocialCardTop fbCardTop'>
                    <a href={'https://www.youtube.com/@' + profileData.socialUrls.youtube || '#'} target='_blank' rel='noopener noreferrer'>
                      <img src={icYoutube} alt="" />
                    </a>

                    <div>
                      <p>Subscribers</p>
                      <h4>{formatNumber(socialStats.youtube.subscribers || 0)}</h4>
                    </div>
                  </div>

                  <div className='profileSocialCont'>
                    <div>
                      <p>Impression</p>
                      <h4>{formatNumber(socialStats.youtube.impressions || 0)}</h4>

                      <br />

                      <p>Average View Duration</p>
                      <h4>{formatNumber(socialStats.youtube.avgViewDuration || 0)}</h4>
                    </div>

                    <div className='profilesocialChart'>
                      <Chart
                        options={data.options}
                        series={data.series}
                        type="bar"
                        height={200}
                        width={150}
                        className="socialChart"
                      />
                      <div className='bottomSocialStats'>
                        <p>Last 90 Days</p>
                        <a href={'https://youtube.com/@' + profileData.socialUrls.youtube || '#'} target='_blank' rel='noopener noreferrer'>Open Youtube</a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>

          </section>
        )}

        {activeTab === 'subscriptions' && (
          <section className='edtSubsription2'>
            <div className='profileStatMain1 socialSubsLeft'>
              <div className='profileStatMain1Top'>
                <div className='profileStatMain1Top1'>
                  <FontAwesomeIcon icon={faFaceSmile} /> <span>Profile</span>
                </div>
                <div className='profileStatMainCont'>
                  <p>Hi, im {userName}</p>
                  <h6>Date Joined</h6>
                  <p><FontAwesomeIcon icon={faClock} /> {dateJoined}</p>
                  <h6>Profile Views</h6>
                  <p><FontAwesomeIcon icon={faEye} /> {profileViews} Views</p>
                  <h6>Profile Card</h6>
                  <p style={{ cursor: 'pointer', color: '#0d6efd' }} onClick={() =>
                    setShowSocialModals((prev) => ({ ...prev, ["image"]: true }))
                  }><FontAwesomeIcon icon={faIdCard} /> View card</p>

                  <button className="shareButton" onClick={handleCopyLink}>
                    <FontAwesomeIcon icon={faShareAlt} />
                    Share My Account
                  </button>
                </div>
              </div>
            </div>

            <div className='profileStatMain2'>



              {profileData.subscriptionEnabled && profileData.subscriptionPrice ? (
                <div className='socialCard22'>
                  <div className='socialCardTop'>
                    <img src={subsImg} alt="" />
                    <div>
                      <p>Monthly Subscription</p>
                      <h3>
                        KES.{profileData.subscriptionPrice ? Number(profileData.subscriptionPrice).toLocaleString() : 0}
                      </h3>

                      <p>Per Month</p>
                    </div>
                  </div>

                  <div className='socialCardCont'>
                    <h6>Package Detail</h6>
                    <ul>
                      {profileData.packageDetails?.length > 0
                        ? profileData.packageDetails.map((item, i) => <li key={i}>{item}</li>)
                        : <li>No details available</li>}
                    </ul>

                    <h6>About</h6>
                    <p>This amount will be billed after every cycle of 30 days</p>
                  </div>




                </div>
              ) : (
                <p>You have not enabled subscription</p>
              )}

              {isSubscriptionActive ? (
                <div className="verifyAccVerified alert alert-success mt-2">
                  <FontAwesomeIcon icon={faCheckCircle} /> Subscription is active
                  {subscriptionExpiry && (
                    <div className="verifyAccMuted">
                      Service expires on {subscriptionExpiry.toLocaleDateString()}
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <div className='alert alert-warning mt-2'>
                    <p>Your subscription to this service has expired or not active, <Link to="/verify-account">renew it here</Link> or <Link to="/edit-profile">activate it here</Link></p>
                  </div>
                </>
              )}

            </div>
          </section>
        )}

        {activeTab === 'tip' && (
          <section className='edtSubsription'>
            <h3>Tip Influencer</h3>
            {/* Tip form, e.g., input for amount, button to pay */}
          </section>
        )}




      </div>
      <div className="mobileOnly">
        <BottomNav />
      </div>

      <SocialCardModal
        show={showModal}
        onHide={() =>
          setShowSocialModals(prev => ({ ...prev, ["image"]: false }))
        }
        userProfile={userProfile}
        infName={userName}

      />


    </div>
  )
}

export default Profile